<template>
  <div class="choices">
    <div v-if="type === 'single'">
      <v-radio-group v-model="selected">
        <v-radio
          :value="choice.id"
          :label="choice.text"
          color="primary"
          :disabled="choice.disabled"
          hide-details
          v-for="(choice, i) in value"
          :key="`choice-${i}`"
        ></v-radio>
      </v-radio-group>
    </div>

    <div v-if="type === 'multiple'">
      <div v-for="(choice, i) in value" :key="`choice-${i}`">
        <v-checkbox
          v-model="choice.selected"
          :label="choice.text"
          color="primary"
          :disabled="choice.disabled"
          hide-details
          @change="change(choice)"
        ></v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Choices',

  props: ['value', 'max', 'type'],

  data () {
    return {
      choiceType: 'checkbox',
      selected: ''
    }
  },

  mounted () {
    this.choiceType = this.type === 'single' ? 'radio' : 'checkbox'
  },

  methods: {
    change (choice) {
      if (this.type === 'multiple') {
        let selected = this.value.filter(c => c.selected).length

        if (selected >= parseInt(this.max)) {
          // max number of selected reached
          this.value.forEach(v => {
            if (!v.selected) {
              v.disabled = true
            }
          })
        } else {
          // less then the max number of allowed
          this.value.forEach(v => {
            if (v.disabled) {
              v.disabled = false
            }
          })
        }
      } else {
        this.value.forEach(v => { v.selected = false })
        console.log(this.value.find(v => v.id === choice.id))
        this.value.find(v => v.id === choice.id).selected = true
      }
    }
  },

  computed: {
    isMultipleChoice () {
      return this.choiceType === 'multiple'
    }
  },

  watch: {
    selected () {
      this.value.forEach(choice => (choice.selected = choice.id === this.selected))
    }
  }
}
</script>

<style lang="scss">
.v-input--is-disabled {
  label {
    text-decoration: line-through;
  }
}
</style>
